export class Signup {
  email: string | undefined;
  first_name: string | undefined;
  last_name: string | undefined;
}
